/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ km: NonNullable<unknown>, place: NonNullable<unknown> }} Opportunitiesnearplace2Inputs */

const en_opportunitiesnearplace2 = /** @type {(inputs: Opportunitiesnearplace2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.km} km from ${i?.place}`)
};

const de_opportunitiesnearplace2 = /** @type {(inputs: Opportunitiesnearplace2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.km} km von ${i?.place}`)
};

/**
* | output |
* | --- |
* | "{km} km from {place}" |
*
* @param {Opportunitiesnearplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesnearplace2 = /** @type {((inputs: Opportunitiesnearplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesnearplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesnearplace2(inputs)
	return de_opportunitiesnearplace2(inputs)
});
export { opportunitiesnearplace2 as "opportunitiesNearPlace" }